export default {
  serverURI: '',
  fixedLayout: false,
  hideLogoOnMobile: false,
  project: 'sd222021',
  projectCNPJ: '09074920000129',
  loginNameProject: 'JA EMBALAGENS'
}



// WEBPACK FOOTER //
// ./src/config/index.js